/** Build a path to return to after login/register. */
export function buildReturnPath(location) {
  if (!location?.pathname) return '/';
  return `${location.pathname}${location.search || ''}${location.hash || ''}`;
}

/** Only allow in-app storefront paths (not account/admin). */
export function isSafeReturnPath(path) {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('/account')) return false;
  if (path.startsWith('/admin')) return false;
  return true;
}

/** Where to send the user after auth — pending bag add always goes to cart. */
export function resolvePostAuthPath({ from, pendingCart }) {
  if (pendingCart?.productId) return '/cart';
  if (isSafeReturnPath(from)) return from;
  return null;
}
